import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const JavaScriptEmbed = ({ js }) => {
  const divRef = useRef(null);

  useEffect(() => {
    if (!js) return;
    const jsTags = js.match(/<script\b[^>]*>([\s\S]*?)<\/script>/gm);
    if (!jsTags?.join()) return;

    const fragment = document.createRange().createContextualFragment(js);

    // Deduplicate external scripts
    const existingScriptsWithSrc = Array.from(
      document.querySelectorAll('script[src]')
    );
    fragment.querySelectorAll('script[src]').forEach(scriptNode => {
      const src = scriptNode.getAttribute('src');
      const hasDuplicateScript =
        src &&
        existingScriptsWithSrc.some(
          existingScript => existingScript.getAttribute('src') === src
        );
      if (hasDuplicateScript) {
        scriptNode.parentNode.removeChild(scriptNode);
      }
    });

    // Deduplicate inline scripts
    fragment.querySelectorAll('script[id]').forEach(scriptNode => {
      const id = scriptNode.getAttribute('id');
      const existingElement = id ? document.getElementById(id) : null;
      if (existingElement?.tagName === 'SCRIPT') {
        scriptNode.parentNode.removeChild(scriptNode);
      }
    });

    const container = divRef.current;
    if (!container) return;
    container.innerHTML = '';
    container.appendChild(fragment);
  }, [js]);

  return <div ref={divRef} />;
};

JavaScriptEmbed.propTypes = {
  js: PropTypes.string,
};

export default JavaScriptEmbed;
